import React, { createContext, useState, useEffect, useContext } from 'react';
import { onAuthStateChanged, getIdTokenResult } from 'firebase/auth'; 
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../servicios/firebase';

export const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          await getIdTokenResult(firebaseUser, true); 

          const userDocRef = doc(db, 'usuarios', firebaseUser.uid);
          const userSnapshot = await getDoc(userDocRef);
          
          if (userSnapshot.exists()) {
            setUser({ ...userSnapshot.data(), uid: firebaseUser.uid });
          } else {
            console.warn("Usuario sin documento en Firestore");
            setUser(null); 
          }
        } catch (error) {
          console.error("Error obteniendo usuario:", error);
          setUser(null);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, []);

  const value = { user, loading };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};